import { forwardRef } from "react";

import { Form } from "@shared/components";
import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getCompaniesService } from "@modules/companies/services/queries/listCompanies/service";

export const CompaniesAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete {...props} ref={ref} queryHook={getCompaniesService} />
  );
});

CompaniesAutocomplete.displayName = "CompaniesAutocomplete";
